import React from "react";
import DriverRegistrationWithoutVehicle from "../screens/Signin/DriverWithNoVehicle";
import Layout from "../layouts";

const driverRegistrationWithoutVehiclePage = () => {
  return (
    <Layout>
      <DriverRegistrationWithoutVehicle />
    </Layout>
  );
};

export default driverRegistrationWithoutVehiclePage;
